import React from 'react';
import { Col, Row } from 'reactstrap';
import { Scorecard } from '../../../../../../../../entities/applicant_tracking/Scorecard';

interface PropTypes {
  scorecard: Scorecard;
}

interface TextBodyPropTypes {
  title: string;
  text: string;
}

function TextBody(props: TextBodyPropTypes) {
  return (
    <Col xs='6' className='d-flex align-items-stretch'>
      <div className='p-3 border border-blue-gray-200 rounded-2 flex-fill'>
        <div className='fs-4 fw-bold text-primary-dark mb-3'>{props.title}</div>
        <div className='fs-5 text-dark-500 mt-1 text-dark-500'>
          {props.text}
        </div>
      </div>
    </Col>
  );
}

export function ProsAndCons(props: PropTypes) {
  return (
    <Row className='mt-2 mb-3'>
      <TextBody title='Pros' text={props.scorecard.pros} />
      <TextBody title='Cons' text={props.scorecard.cons} />
    </Row>
  );
}
